import { useEffect, useState } from "react";
import { useLocation } from "react-router";

const useIsLiveTv = () => {
  const { pathname } = useLocation();
  const [isLiveTv, setIsLiveTV] = useState(pathname.startsWith("/live"));

  useEffect(() => {
    setIsLiveTV(pathname.startsWith("/live"));
  }, [pathname]);

  return isLiveTv;
};

export default useIsLiveTv;
